module.exports = "/images/document.svg?37e21d47b281624fb154c04e3dcefa4a";